// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3kTlv","buttons":"PendingPaymentAlert_buttons__24Jgc"};